<template>
  <div v-if="!webViewMode" class="footer fill-width" :class="{ 'color-wall-text': !postColors, 'color-post-text': postColors }">
    <div class="links-footer d-flex flex-column align-center mt-4 pb-4">
      <div v-if="showThirdPartySoftwareLink" class="d-flex mt-n1 mb-1">
        <the-button class="font-weight-bold font-size-small" text small no-hover custom-colors :to="{ name: $routes.THIRD_PARTY_SOFTWARE }">
          {{ $translate("TheFooter.thirdPartySoftware") }}
        </the-button>
      </div>
      <div class="d-flex align-center">
        <button type="button" class="font-weight-bold px-1 footer-button" tabindex="0" @click="showLegalDocument = 'support'">
          {{ $translate("TheFooter.support") }}
        </button>
        <i-custom-dot class="size-1" />
        <button type="button" class="font-weight-bold px-1 footer-button" tabindex="0" @click="showLegalDocument = 'privacyPolicy'">
          {{ $translate("TheFooter.privacy") }}
        </button>
        <i-custom-dot class="size-1" />
        <button type="button" class="font-weight-bold px-1 footer-button" tabindex="0" @click="showLegalDocument = 'termsConditions'">
          {{ $translate("TheFooter.terms") }}
        </button>
        <template v-if="!configuration.whiteLabel">
          <i-custom-dot class="size-1" />
          <i18n-t keypath="common.poweredBy" tag="span" scope="global" class="mx-1">
            <a href="https://www.disciplemedia.com/?utm_source=app&utm_medium=pwa&utm_campaign=footer_link" target="_blank" class="font-weight-bold">
              Disciple
            </a>
          </i18n-t>
        </template>
      </div>
    </div>

    <legal-documents :type="showLegalDocument" @close="showLegalDocument = null" />
  </div>
</template>

<script>
import { mapGetters } from "pinia"

import { useAppStateStore } from "@/store/appState.js"
import { useConfigurationStore } from "@/store/configuration.js"

import LegalDocuments from "@/components/LegalDocuments.vue"

export default {
  components: {
    LegalDocuments
  },
  props: {
    postColors: {
      type: Boolean,
      default: false
    },
    showThirdPartySoftwareLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showLegalDocument: null
    }
  },
  computed: {
    ...mapGetters(useConfigurationStore, ["configuration"]),
    ...mapGetters(useAppStateStore, ["webViewMode"])
  }
}
</script>

<style lang="scss" scoped>
.footer-button:focus-visible {
  outline: 2px solid !important;
  border-radius: 2px;
}

.v-divider {
  opacity: 0.1;
}

.links-footer {
  font-size: var(--font-size-small);
  opacity: 0.6;
}
</style>
